import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import { useLoad } from '../../hooks/request'
import { CONTRACT_LIST } from '../../urls'
import Select from '../../components/common/Select'

export default function PaymentForm({ onCancel, onSubmit, loading, initialValues }) {
    const contract = useLoad({ url: CONTRACT_LIST })
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                contract: '',
                paymentDate: '',
                amountPaid: '',
                ...initialValues,
            }}
        >
            <Form>
                <div className="columns">
                    <div className="column">

                        <Select
                            empty
                            options={contract.response?.results ?? []}
                            name="contract"
                            optionValue="id"
                            optionLabel={(e) => e.selectCustomer?.fullName ?? ''}
                            label="Шартнома"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="paymentDate"
                            type="date"
                            label="Тўлов вақти"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="amountPaid"
                            label="Тўлов суммаси"
                            validate={required}
                            disabled={loading}
                        />

                    </div>
                </div>

                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button
                            onClick={onCancel}
                            icon="close-outline"
                            text="Ёпиш"
                            className="is-danger"
                        />
                    </div>
                    <div className="button-wrapper">
                        <Button
                            loading={loading}
                            text="Сақлаш"
                            icon="add-outline"
                            type="submit"
                            className="is-success"
                        />
                    </div>
                </div>
            </Form>

        </Formik>
    )
}
